import { SpinResponse } from '@cgs/data-access';
import { CgsEvent } from '@cgs/wge';
import { ResponseHolder } from '../response_holder';
import { BaseGameState } from '../states/base_game_state';
import { BaseGameRule } from './infra/base_game_rule';

export class WaitResponseEventRule<TResponse extends SpinResponse> extends BaseGameRule<TResponse> {
  constructor(sourceState: BaseGameState<TResponse>, responseHolder: ResponseHolder<TResponse>) {
    super(sourceState, responseHolder);
  }

  // The inherited BaseGameRule.dispatchEvent triggers on ANY event without
  // checking for a server response: a StopEvent dispatched while accelerate
  // still waits for the response (e.g. held spacebar → SDK fastForward →
  // doStop) forced this transition without consuming anything, so the reels
  // stopped on a stale curResponse (on the first spin — the start state with
  // empty viewReels). Events must run the same guarded consume as update().
  dispatchEvent(_event: CgsEvent): void {
    this.update(0);
  }

  update(_dt: number): void {
    if (
      this.responseHolder.curServerResponse &&
      this.ruleCondition(this.responseHolder) &&
      this.sourceState.isFinished
    ) {
      const response = this.responseHolder.curServerResponse;
      this.responseHolder.curServerResponse = null;
      this.responseHolder.preResponse = this.responseHolder.curResponse;
      this.responseHolder.curResponse = response;
      this.triggered = true;
    }
  }
}
